import { ValueOf } from '@appTypes';
import { Originators, PathnamePrefixes, HeyLightPath } from '@utils/constants';

export type PathnamePrefix = ValueOf<typeof HeyLightPath>;

export const getPathnamePrefixForOriginator = (
  originator: keyof typeof PathnamePrefixes,
): PathnamePrefix =>
  originator === Originators.HEIDIPAY ? HeyLightPath.CH : HeyLightPath.IT;
